import {StyledDashboardCard} from './style'
import {Text} from '@/components/ui/text/Text'

interface DashboardCardProps {
    title?: string
    children: React.ReactNode
}

export const DashboardCard = ({title, children}: DashboardCardProps) => (
    <StyledDashboardCard>
        <Text palette="neutral" shade="600" size="textMd" weight={500}>
            {title}
        </Text>
        {children}
    </StyledDashboardCard>
)
